import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { Row, Col, Form } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { PricingOptionsTable } from './PricingOptionsTable';
import { DropdownOption } from '@app/models/DropdownOption';
import { CrudSettingsContext } from '@app/contexts/CrudSettingsContext';
import { ProductPricing } from '@app/models/product_pricing/ProductPricing';
import { PricingOptionsContext } from './ProductPricingForm';

type ProductPricingDetailsProps = {
  pricingStrategyOptions: DropdownOption[];
  departmentOptions: DropdownOption[];
  statusOptions: DropdownOption[];
  modelTypeOptions: DropdownOption[];
  productPricing: ProductPricing | null;
  mode: 'view' | 'edit' | 'create';
};

const ProductPricingDetails: React.FC<ProductPricingDetailsProps> = ({
  mode,
  modelTypeOptions,
  statusOptions,
  pricingStrategyOptions,
  departmentOptions,
}) => {
  const pricingContext = useContext(PricingOptionsContext);
  const readOnly = mode == 'view';
  const requiredMark = !readOnly;

  return (
    <Row gutter={16}>
      <Col xs={24} md={24} lg={12}>
        <Form.Item name="code" label="Code" rules={[{ required: requiredMark }]}>
          <BaseInput readOnly={readOnly} />
        </Form.Item>
      </Col>
      <Col xs={24} md={24} lg={12}>
        <Form.Item name="pricing_strategy" label="Pricing Strategy" rules={[{ required: requiredMark }]}>
          {readOnly ? (
            <BaseInput readOnly={readOnly} />
          ) : (
            <BaseSelect
              options={pricingStrategyOptions}
              onChange={(e: any) => {
                pricingContext.setSelectedPricingStrategy(e);
              }}
            ></BaseSelect>
          )}
        </Form.Item>
      </Col>
      <Col xs={24} md={24} lg={12}>
        <Form.Item name="department_id" label="Department" rules={[{ required: requiredMark }]}>
          {readOnly ? <BaseInput readOnly={readOnly} /> : <BaseSelect options={departmentOptions}></BaseSelect>}
        </Form.Item>
      </Col>
      {pricingContext.selectedPricingStrategy !== '' && pricingContext.selectedPricingStrategy != 'FR' && (
        <Col xs={24} md={24} lg={12}>
          <Form.Item name="unit" label="Unit" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
      )}
      <Col xs={24} md={24} lg={12}>
        <Form.Item name="model_type" label="Model Type" rules={[{ required: requiredMark }]}>
          {readOnly ? <BaseInput readOnly={readOnly} /> : <BaseSelect options={modelTypeOptions}></BaseSelect>}
        </Form.Item>
      </Col>
      <Col xs={24} md={24} lg={12}>
        <Form.Item name="status" label="Status" rules={[{ required: requiredMark }]}>
          {readOnly ? <BaseInput readOnly={readOnly} /> : <BaseSelect options={statusOptions}></BaseSelect>}
        </Form.Item>
      </Col>
      <Col span={24}>
        <PricingOptionsTable mode={mode} />
      </Col>
    </Row>
  );
};

export default ProductPricingDetails;
